import Vue from "vue";
import Vuetify from "vuetify/lib";
import fa from "vuetify/es5/locale/fa";
import "@mdi/font/css/materialdesignicons.min.css";

Vue.use(Vuetify);

export default new Vuetify({
  rtl: true,
  lang: {
    locales: { fa },
    current: "fa"
  },
  icons: {
    iconfont: "mdiSvg" // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  theme: {
    themes: {
      light: {
        primary: "#3C8FD1",
        secondary: "#803CD1",
        accent: "#8338EC",
        error: "#FF5670",
        info: "#F4A046",
        success: "#3CD1A2",
        warning: "#F4C346"
      }
    }
  }
});
